/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

enum CollectionKind {
  Candle,
  LipBalm,
  LipScrub,
}

export default CollectionKind;
